<template>
  <div id="breadcrumb">
    <ol class="breadcrumbCustom">
      <li v-for="(item, index) in path" :key="'item-' + index" :class="{ item, active: path.length > index + 1 }">
        <router-link
          v-if="item.linkName"
          :to="{ name: path.length > index + 1 ? item.linkName : '', query: { emi: merchantId } }"
        >
          <a>{{ $t(item.name) }}</a>
        </router-link>
        <span v-else>
          <a>{{ $t(item.name) }}</a>
        </span>
      </li>
    </ol>
  </div>
</template>

<script lang="ts">
import { MerchantId } from "@/helper/userHelper";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreBreadcrumb = namespace("Breadcrumb");

@Component
export default class Breadcrumb extends Vue {
  private path: Array<any> = [];

  @StoreBreadcrumb.Getter
  private getBreadcrumb!: Array<any>;
  private merchantId = MerchantId().PeakEncryption();

  get getPath(): any {
    return this.$route.meta?.breadcrumb;
  }

  get route(): any {
    return this.$route;
  }

  @Watch("route", { immediate: true, deep: true })
  routeChanged(newVal: any, oldVal: any) {
    this.SetBreadcrumb();
  }

  @Watch("getBreadcrumb")
  getBreadcrumbChanged(newVal: any, oldVal: any) {
    this.SetBreadcrumb();
  }

  public SetBreadcrumb() {
    this.path.length = 0;
    const path = this.$route.meta?.breadcrumb;
    if (path && path.length > 0) {
      path.forEach((item: any) => {
        if (item) {
          this.path.push(item);
        }
      });
    }

    if (this.getBreadcrumb && this.getBreadcrumb.length > 0) {
      this.getBreadcrumb.forEach((item: any) => {
        if (item) {
          this.path.push(item);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
#breadcrumb {
  margin-top: 10px;
  margin-bottom: 20px;
  .breadcrumbCustom {
    list-style-type: none;
    margin: 0;
    padding: 0;
    li {
      display: inline;
      padding: 0px;
    }
    .active {
      a {
        color: $blue_default !important;
        &:hover {
          background: #e8eff8;
        }
      }
    }
    .item {
      a {
        color: $textDisabled;
        cursor: pointer;
        border-radius: 6px;
        padding: 2px 10px;
        transition: 0.5s !important;
      }
    }
    .item:before {
      padding: 0px 0px;
      color: $textDisabled;
      content: ">";
    }
    .item:first-child {
      &:before {
        content: "";
      }
    }

    .item:last-child {
      a {
        cursor: unset;
        &:hover {
          background: unset;
        }
      }
    }
  }
}
</style>
